import React, { createContext, useContext, useState } from "react";

const DateFilterContext = createContext();

export const DateFilterProvider = ({ children }) => {
  const [date, setDate] = useState(null);

  return (
    <DateFilterContext.Provider value={{ date, setDate }}>
      {children}
    </DateFilterContext.Provider>
  );
};

export const useDateFilter = () => {
  const ctx = useContext(DateFilterContext);
  if (!ctx) throw new Error("DateFilter must be used inside provider");
  return ctx;
};
